import { render, staticRenderFns } from "./BlobMask.vue?vue&type=template&id=46dcb420&scoped=true"
import script from "./BlobMask.vue?vue&type=script&lang=js"
export * from "./BlobMask.vue?vue&type=script&lang=js"
import style0 from "./BlobMask.vue?vue&type=style&index=0&id=46dcb420&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dcb420",
  null
  
)

export default component.exports